import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Button.css';
import { Spinner, useBoolean } from '@chakra-ui/react';

const Button = (props) => {
  return (<button
    onClick={props.onClick}
    disabled={props.disabled}
    className={`bf-btn bf-btn-${props.variant} ${(!!props.className) ? props.className : ''} bf-btn-${props.size}`}>
    {props.children}
  </button>)
}

export { Button }

const ButtonLoading = (props) => {
  
  const [loading, setLoading] = useBoolean();
  const onClick = () => {
    setLoading.on();
    props.callback(props.args)
      .finally(_ => setLoading.off())
  }
  return (
    <Button {...props} onClick={onClick}>
      {(loading) ? <Spinner size='xs' className="spinner" /> : props.icon}
      {(!!props.label) ? <span>{props.label}</span> : null}
    </Button>)
}

export { ButtonLoading }

const ButtonToggle = (props) => {
  const [state, setState] = useState();
  const onClick = () => {
    setState(prevState => !prevState);
    props.onClick(state);
  };
  return <Button {...props} onClick={onClick}>
    {(state) ? props.on : props.off}
  </Button>
}

export { ButtonToggle }

const ButtonIcon = Button;
export { ButtonIcon }

Button.defaultProps = {
  variant: 'default',
  type: 'button',
  size: 'auto'
}

Button.propType = {
  children: PropTypes.any,
  variant: PropTypes.oneOf(['default', 'alternative', 'dark', 'light', 'green', 'red', 'yellow', 'purple', 'transparent']),
  onClick: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.string
}